import {Component, Input} from '@angular/core';
import {ArchivedProtection} from '@emma-labs/shared/typescript';
import {CardModule} from 'primeng/card';
import {NeedsReminderSectionComponent} from '../../proposal-page/coverage-builder-section/needs-reminder-section/needs-reminder-section.component';
import {SelectedProductSectionComponent} from '../../proposal-page/coverage-builder-section/selected-product-section/selected-product-section.component';

@Component({
  selector: 'em-archived-protection-section',
  templateUrl: './archived-protection-section.component.html',
  imports: [CardModule, NeedsReminderSectionComponent, SelectedProductSectionComponent],
})
export class ArchivedProtectionSectionComponent {
  @Input({required: true}) needs!: number;
  @Input({required: true}) protection!: ArchivedProtection;
}
